<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import { baseProps } from '@/libs/utils/forms/baseProps.js'

export default {
  components: {
    Label
  },
  props: {
    ...baseProps,
    value: {
      type: [String, Boolean],
      default: ''
    },
    options: {
      type: Array,
      default: null
    },
    nameValidation: {
      type: String,
      default: null
    }
  },
  mounted () {
    this.$el.addEventListener('focusout', this.handleFocusOut, true)
  },
  beforeDestroy () {
    this.$el.removeEventListener('focusout', this.handleFocusOut, true)
  },
  methods: {
    updateValue (val) {
      this.$emit('input', val)
    },
    handleFocusOut () {
      if (document.activeElement && document.activeElement.matches('input.el-radio__original')) {
        document.activeElement.blur()
      }
    }
  }
}

</script>

<template>
  <div id="inputForms">
    <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nameValidation">
      <el-col :span="widthColumn" :class="marginLeft ? 'ml-2' : ''">
        <Label v-if="label" :label="label" :obrigatorio="obrigatorio" :Indice="Indice" />
        <el-radio-group
          v-if="options"
          class="radio-group"
          :name="label"
          :value="value"
          @input="updateValue"
          v-for="(option, index) in options" :key="index"
        >
          <el-radio :class="`radio ${ index > 0 ? 'ml-3': ''}`" :label="option.id">{{ option.nome }}</el-radio>
        </el-radio-group>
        <el-radio-group
           v-if="!options"
          class="radio-group"
          :name="label"
          :value="value"
          @input="updateValue"
        >
          <el-radio class="radio" :label="true">Sim</el-radio>
          <el-radio class="radio" :label="false">Não</el-radio>
        </el-radio-group>
        <span class="help erro text-align-center" v-if="errors.length > 0"> {{ errors[0] }}</span>
      </el-col>
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
@import '@/scss/_mixins.scss';
@import '@/scss/_typography.scss';
@import '@/scss/_utilities.scss';
@import './styles.scss';

.erro {
  font-size: small;
  color: $color-error;
  margin-top: 5px;
  display: block;
  white-space: pre;
}

.radio-group.erro {
  border: 1px solid $color-error;
  border-radius: 4px;
  border-color: $color-error;
  -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px $color-error;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}

#inputForms {
  [class^="el-"],
  [class*=" el-"] {
    @include set-rawline-bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/InputRadio/InputRadio.vue